class SkipLinks {
    constructor(elem) {
        this.elem = elem;
        this.focusableElements = `a[href], area[href], input:not([disabled]):not([type='hidden']),
            select:not([disabled]), textarea:not([disabled]),
            button:not([disabled]):not([tabindex="-1"]), iframe`;
    }

    init() {
        this.initElementSkipLink();
    }

    initElementSkipLink() {
        if (!this.elem.classList.contains('skip-links--page-top')) {
            const links = this.elem.querySelectorAll('a');
            links.forEach((link) => {
                link.addEventListener('click', this.handleSkipLinkClick.bind(this));
            });
        }
    }

    handleSkipLinkClick(event) {
        event.preventDefault();
        const nextFocusableElement = this.findNextFocusableElement(event.currentTarget);
        if (nextFocusableElement) {
            nextFocusableElement.focus();
        }
    }

    findNextFocusableElement(currentTarget) {
        let nextElement = this.findNextContainer(currentTarget);

        if (nextElement) {
            const currentIndex = this.focusableElements.indexOf(nextElement);
            if (currentIndex === -1) {
                nextElement = this.findNextContainer(nextElement);
            }

            return nextElement.querySelector(this.focusableElements);
        }

        return null;
    }

    findNextContainer(element) {
        let componentContainer = element.closest('.component-container');
        if (!componentContainer) {
            componentContainer = element.classList.contains('.component-container');
        }

        if (!componentContainer) {
            return false;
        }

        let nextContainer = componentContainer.nextElementSibling;
        if (!nextContainer) {
            nextContainer = document.getElementById('footer');
        }

        return nextContainer;
    }
}

export default SkipLinks;
